/**
 * Where a venue class is booked: its activity's page, with the class named.
 *
 * `/venues/[venue]/experiences/[slug]` is retired — it only redirects here —
 * so every link builds this instead of paying the hop. The bare activity URL
 * opens on All; `experience` picks a class, `start` a time in it, and
 * `reschedule` moves an existing booking rather than making a new one.
 */
export function venueActivityHref({
  hiiveSlug,
  venueSlug,
  activityId,
  experienceSlug,
  start,
  reschedule,
}: {
  hiiveSlug: string;
  venueSlug: string;
  activityId: string;
  experienceSlug?: string | null;
  start?: string | null;
  reschedule?: number | string | null;
}): string {
  const params = new URLSearchParams();
  if (experienceSlug) params.set("experience", experienceSlug);
  if (start) params.set("start", start);
  if (reschedule != null && reschedule !== "") {
    params.set("reschedule", String(reschedule));
  }
  const query = params.toString();
  return `/hiives/${hiiveSlug}/venues/${venueSlug}/activities/${encodeURIComponent(activityId)}${query ? `?${query}` : ""}`;
}
